<template>
  <div class="organization-wrap">

    <div class="organization-right" ref="csRight">

      <div class="csr-wrap">
        <div class="search-wrap">
          <el-input
            class="search-city"
            placeholder="请输入城市名称"
            suffix-icon="el-icon-search"
            v-model="searchCity"
            @input="handleCityInput">
          </el-input>
          <div class="search-result-wrap" v-if="searchResult">
            <el-scrollbar class="page-component__scroll" v-if="this.cityFilter.length > 0">
              <p v-for="item in cityFilter" :key="item.city" @click="handleChangeCity(item.city)">{{item.city}}</p>
            </el-scrollbar>
            <p v-else>抱歉，未能找到相关城市</p>
          </div>
          <span>当前城市：{{currentCity}}</span>
        </div>
        <ul class="letter-wrap">
          <li v-for="item in letterList" :key="item" @click="letterClick(item)"> {{item}} </li>
        </ul>
        <div class="city-list">
          <p>按照省份首字母选择</p>
          <div class="scoll-wrap">
            <el-scrollbar class="page-component__scroll" ref="pageComponentScroll">
              <template v-for="(item) in cityData">
                <div class="city-item" ref="letterCityItem" :key="item.letter" v-if="item.province.length > 0">
                  <div class="city-item-left">
                    <span>{{item.letter}}</span>
                  </div>
                  <div class="city-item-right">
                    <div class="city-province" v-for="(a, b) in item.province" :key="b">
                      <h6>{{a.province.replace(/省|自治区|壮族自治区|回族自治区|维吾尔自治区|特别行政区/, '')}}</h6>
                      <ul>
                        <li v-for="(c,d) in a.orgCityRegionDTO1s || []" :key="d" @click="handleChangeCity(c.city)">
                          {{c.city}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </template>
            </el-scrollbar>
          </div>
        </div>
      </div>
       <div class="org-wrap">
        <div class="search-wrap">
          <el-input
            class="search-org"
            placeholder="请输入机构名称"
            suffix-icon="el-icon-search"
            v-model="searchOrg"
            @input="handleInput">
          </el-input>
          <div class="search-result-wrap" v-if="searchResult">
            <el-scrollbar class="page-component__scroll" v-if="this.orgFilter.length > 0">
              <p v-for="item in orgFilter" :key="item.orgId" @click="handleUrl(item)">{{item.orgName}}</p>
            </el-scrollbar>
            <p v-else>抱歉，未能找到相关机构，请换个城市试试</p>
          </div>
          <span>当前城市：{{currentCity}}</span>
        </div>
        <p class="opportunity"><i class="el-icon-s-opportunity"></i><span>当前搜索结果为{{currentCity}}的机构</span></p>
        <div class="org-container">
          <div class="org-item">
            <h6>机构列表</h6>
            <template  v-if="orgList.length > 0">
              <el-scrollbar class=" school_height page-component__scroll" >
                <p v-for="(item, index) in orgList"   :key="item.id" @click="handleUrl(item)"> <span v-if="index <= 11">{{item.orgName}}</span></p>
              </el-scrollbar>
            </template>
            <p v-else>抱歉，该城市暂无机构</p>
          </div>
          <div class="org-item history-item">
            <h6>历史访问</h6>
            <template  v-if="historyOrganization.length > 0">
              <p v-for="(item) in historyOrganization"  :key="item.id" @click="handleUrl(item)">{{item.orgName}}</p>
            </template>
            <p v-else>抱歉，暂无历史搜索</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import http from '@/http/index'
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    orgList: {
      type: Array
    }
  },
  data () {
    return {
      changeValue: 'org',
      hot: [],
      searchResult: false,
      searchOrg: '',
      orgFilter: [],
      letterList: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      cityData: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').reduce((acc, letter) => {
        acc[`letter${letter}`] = { letter, province: [] }
        return acc
      }, {}),
      searchCity: '',
      cityList: [], // 城市列表 用户搜索过滤
      cityFilter: []
    }
  },
  computed: {
    ...mapState(['historyOrganization', 'currentCity'])
  },
  created () {
    this.getOrgRegionInfo()
  },
  methods: {
    ...mapMutations(['handleHistoryOrganization', 'handleCurrentCity']),
    handleInput (val) {
      const query = val?.trim()
      if (!query) {
        this.searchResult = false
        this.orgFilter = []
        return false
      }

      const lowerQuery = query.toLowerCase()
      this.orgFilter = this.orgList.filter(item => {
        const nameMatch = item.orgName?.toLowerCase().includes(lowerQuery)
        const urlMatch = (item.url || '').toLowerCase().includes(lowerQuery)
        return nameMatch || urlMatch
      })

      this.searchResult = true
    },
    handleUrl (data) {
      const BASE_API_TESTS = process.env.VUE_APP_BASE_API_TESTS
      if (!data.url) return false
      this.searchResult = false
      this.searchOrg = ''
      window.open(BASE_API_TESTS + '#/index?abbr=' + data.url)
      this.$emit('jump')
      this.handleHistoryOrganization(data)
    },
    handleCityInput (val) {
      if (!val) {
        this.cityFilter = []
        this.searchResult = false
        return false
      }

      const query = val.trim()
      this.searchResult = true
      this.cityFilter = this.cityList.filter(item =>
        item.city === query ||
        item.city_initials === query.toUpperCase() ||
        item.city.toLowerCase().includes(query.toLowerCase())
      )
    },
    handleChangeCity (city) {
      this.searchResult = false
      this.searchCity = ''
      this.handleCurrentCity(city)
      this.$emit('handleChangeCity', city)
    },
    getOrgRegionInfo () {
      http.getOrgRegionInfo().then(res => {
        const data = res.data.data
        const temp = []

        // 遍历每个省份
        data.forEach(item => {
          const transformedItem = {
            ...item,
            orgCityRegionDTO1s: item.cityRegionList
          }

          temp.push(transformedItem.orgCityRegionDTO1s)

          // 按首字母分组
          const letter = (item.provinceInitials || '').toUpperCase()
          if (letter && this.cityData[`letter${letter}`]) {
            this.cityData[`letter${letter}`].province.push(transformedItem)
          }
        })

        this.cityList = temp.flat(Infinity)
      })
    },
    letterClick (arg) {
      const letterCityItem = this.$refs.letterCityItem
      letterCityItem.forEach((item, index) => {
        const firstChildrenText = item.children[0].innerText
        if (arg !== firstChildrenText) return
        const offsetT = item.offsetTop // 获取元素距离顶部的距离
        this.ScrollTop(offsetT, 200)
      })
    },
    ScrollTop (number = 0, time) {
      if (!time) {
        this.$refs.pageComponentScroll.wrap.scrollTop = number
        return number
      }
      const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
      let spacingInex = time / spacingTime // 计算循环的次数
      let nowTop = (this.$refs.pageComponentScroll.wrap.scrollTop) // 获取当前滚动条位置
      const everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
      const scrollTimer = setInterval(() => {
        if (spacingInex > 0) {
          spacingInex--
          this.ScrollTop((nowTop += everTop))
        } else {
          clearInterval(scrollTimer) // 清除计时器
        }
      }, spacingTime)
    }
  },
  mounted () {
    this.$refs.csRight.addEventListener('click', (e) => {
      if (e.target.className !== 'search-result-wrap') {
        this.searchResult = false
      }
    })
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/sass/variable.scss';

::v-deep(.page-component__scroll) {
  height: 100%;
}

::v-deep(.page-component__scroll .el-scrollbar__wrap){
  overflow-x: auto;
}

.organization-wrap {
  width: 900px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04) !important;

  .organization-left {
    ul {
      padding: 18px 0;

      li {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 20px 20px;
        background: rgba(27, 56, 202, .1);
        font-size: 18px;
        color: #fff;

        &.active {
          background: rgba(0,0,0,.1);
        }
      }
    }
  }

  .opportunity {
    padding: 10px 0 0;
    color: #FF8B00;
    i {
      margin-right: 10px;
    }
  }

  .organization-right {
    background: #fff;
    float: left;

    .org-wrap {
      padding: 28px 38px 0;

      .search-wrap {
        display: flex;
        align-items: center;
        position: relative;

        .search-result-wrap {
          width: 900px;
          height: 200px;
          position: absolute;
          top: 37px;
          left: 0;
          z-index: 1;
          background: #fff;
          box-shadow: 0 0 20px rgba(0,0,0,.1);
          border-radius: 5px;

          p {
            line-height: 30px;
            padding: 0 20px;
            color: #101D37;
            font-size: 14px;

            &:hover {
              background: #f8f8f9;
              color: $el-main-color;
            }
          }
        }

        .search-org {
          width: 580px;
          height: 36px;
          margin-right: 25px;
        }

        span {
          font-size: 16px;
          color: #8C8E9E;
        }
      }

      .org-container {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        .org-item {
          width: 200px;
          height: 230px;
          padding: 20px;

          h6 {
            font-size: 16px;
            color: #474964;
            padding-bottom: 20px;
            border-bottom: 1px solid #D1D2D8;
          }

          p {
            font-size: 14px;
            color: #474964;
            line-height: 30px;

            &:hover {
              color: $el-main-color;
            }
          }
        }

        .history-item {
          background: #F6F7F9;
        }
      }
    }

    .csr-wrap {
      padding: 28px 38px 0;

      .search-wrap {
        display: flex;
        align-items: center;
        position: relative;

        .search-result-wrap {
          width: 900px;
          height: 200px;
          position: absolute;
          top: 37px;
          left: 0;
          z-index: 1;
          background: #fff;
          box-shadow: 0 0 20px rgba(0,0,0,.1);
          border-radius: 5px;

          p {
            line-height: 30px;
            padding: 0 20px;
            color: #101D37;
            font-size: 14px;

            &:hover {
              background: #f8f8f9;
              color: $el-main-color;
            }
          }
        }

        .search-city {
          width: 580px;
          height: 36px;
          margin-right: 25px;
        }

        span {
          font-size: 16px;
          color: #8C8E9E;
        }
      }

      .letter-wrap {
        display: flex;
        justify-content: space-around;
        margin: 24px 0 14px;

        li {
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          font-size: 16px;
          color: #474964;
          border-radius: 50%;

          &:hover {
            background: #F6F7F9;
          }
        }
      }

      .city-list {
        p {
          font-size: 16px;
          color: #101D37;
          font-weight: bold;
        }

        .scoll-wrap {
          height: 280px;
          border: 1px solid #DDDDDD;
          border-radius: 5px;
          margin-top: 19px;

          &.active {
            animation: shake .3s ease-in-out;
          }

          .city-item {
            border-bottom: 1px solid #DDDDDD;
            position: relative;

            &:last-child {
              border-bottom: none;
            }

            .city-item-left {
              position: absolute;
              top: 0;
              bottom: 0;
              width: 55px;
              background-color: #F6F7F9;
              font-size: 18px;
              color: #101D37;
              text-align: center;
              font-weight: bold;

              span {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                height: 24px;
                line-height: 24px;
                margin: auto;
                font-size: 24px;
              }
            }

            &:hover {
              .city-item-left {
                background: $el-main-color;
                color: #fff;
              }
            }

            .city-item-right {
              margin-left: 55px;

              .city-province {
                padding: 14px 0;
                line-height: 27px;
                position: relative;

                &::after {
                  content: '';
                  display: block;
                  width: 0;
                  height: 0;
                  border-top: 8px solid transparent;
                  border-bottom: 8px solid transparent;
                  border-left: 8px solid $el-main-color;
                  position: absolute;
                  left: 0;
                  top: 20px;
                  opacity: 0;
                }

                &:hover::after {
                  opacity: 1;
                }

                h6 {
                  width: 60px;
                  float: left;
                  margin-left: 25px;
                  font-weight: bold;
                  font-size: 16px;
                  color: #101D37;
                }

                ul {
                  margin-left: 85px;
                  padding-right: 8px;

                  li {
                    display: inline-block;
                    margin-right: 12px;
                    cursor: pointer;
                    color: #101D37;
                    font-size: 14px;

                    &:hover {
                      color: $el-main-color;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.search-wrap ::v-deep .el-input__inner {
  height: 36px;
  background: #F6F7F9;
  border-radius: 18px;
}

.school_height{
  height: 200px;
}
</style>
